import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import DashboardLayout from "./components/layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Flows from "./pages/Flows";
import Logs from "./pages/Logs";
import Settings from "./pages/Settings";
import ApiKeys from "./pages/ApiKeys";
import Monitor from "./pages/Monitor";

function App() {
  return (
    <div className="noise-bg">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="flows" element={<Flows />} />
            <Route path="logs" element={<Logs />} />
            <Route path="monitor" element={<Monitor />} />
            <Route path="api-keys" element={<ApiKeys />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
